module.exports = __webpack_public_path__ + "img/boxed-22.dc8127df.jpg";